module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Eingang3.9ba45799.jpg";